export default "__VITE_ASSET__5a98a12b__"